import { useState } from 'react';
import moment from 'moment';

const getInstallPromptLastSeenAt = (promptName: string): string | null => {
  return localStorage.getItem(promptName);
};

const getUserShouldBePromptedToInstall = (promptName: string, daysToWaitBeforePromptingAgain: number): boolean => {
  const lastPrompt = moment(getInstallPromptLastSeenAt(promptName));
  const daysSinceLastPrompt = moment().diff(lastPrompt, 'days');
  return isNaN(daysSinceLastPrompt) || daysSinceLastPrompt > daysToWaitBeforePromptingAgain;
};

const useShouldShowPrompt = (promptName: string, daysToWaitBeforePromptingAgain: number = 1): [boolean, () => void] => {
  const [userShouldBePromptedToInstall, setUserShouldBePromptedToInstall] = useState<boolean>(
    getUserShouldBePromptedToInstall(promptName, daysToWaitBeforePromptingAgain)
  );

  const handleUserSeeingInstallPrompt = (): void => {
    setUserShouldBePromptedToInstall(false);
    localStorage.setItem(promptName, moment().toISOString());
  };

  return [userShouldBePromptedToInstall, handleUserSeeingInstallPrompt];
};

export default useShouldShowPrompt;
